import { Component, OnInit } from '@angular/core';
import { MobileService } from './mobile.service';
import { NoticeService } from '../notice/notice.service';


@Component({
    selector: 'mobile-main',
    templateUrl: 'mobile-main.component.html',
    providers: [MobileService, NoticeService]
})
export class MobileMainComponent implements OnInit {

    takenCargoCount: number;
    noticeCount: number;

    constructor(
        private mobileService: MobileService,
        private noticeService: NoticeService
    ) {  }
 

    ngOnInit() {
        this.getTakenCargoCount();
        this.getNoticeCount();
        //this.sendGeolocation();
    }



    getTakenCargoCount() {
        this.mobileService.getTakenCargoCount()
        .subscribe(
            data => {
                this.takenCargoCount = data['count'];
            }
        );
    }

    getNoticeCount() {
        this.noticeService.getNoticeCount()
        .subscribe(
            data => {
                this.noticeCount = data['count'];
            }
        );
    }

    /*
    getDriverCargoList() {
        this.mobileService.getDriverCargoList()
        .subscribe(
            data => {
                this.cargoList = data['results'];
                this.totalCount = data['count'];
            }
        );
    }

    getNoticeList() {
        this.noticeService.getNoticeList(1, false)
        .subscribe(
            data => {
                this.noticeCount = data['count'];
                this.noticeList = data['results'];
            }
        );
    }
    */

    


   sendGeolocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(   //only https
                //successの場合
                function(position){ console.log(position); },
                //errorの場合
                function(){ console.log("getCurrentPosition error!!"); }
            );
        }
    }

}
    


// WEBPACK FOOTER //
// ./src/app/mobile/mobile-main.component.ts